import React from "react";
import WizardPageWrapper, { GeneralPageSummary } from "../WizardPageWrapper";
import Flex from "../../../../../../components/Flex";
import FileDropzone from "../FileDropzone";
import { Form, Input } from "antd";
import { CoverWizardForm } from "../../CoverWizardModal";

type MeasurementsPageProps = {
  wizardPageNumberState: [number, React.Dispatch<React.SetStateAction<number>>];
  onNextButtonClick?: () => void;
  onBackButtonClick?: () => void;
};

const allowedFileExtensions = ["pdf"];

const dropzoneFieldName = "measurementsDocuments";
const distanceFieldName = "distanceFromAB";

function normFile(e: any) {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
}

export default function MeasurementsPage({
  wizardPageNumberState: [wizardPageNumber, setWizardPageNumber],
  onNextButtonClick,
  onBackButtonClick,
}: MeasurementsPageProps) {
  const form = Form.useFormInstance<CoverWizardForm>();

  const fileList = Form.useWatch(dropzoneFieldName, form) ?? [];

  return (
    <WizardPageWrapper
      title="Measurements"
      summary={<GeneralPageSummary />}
      onBackButtonClick={onBackButtonClick}
      onNextButtonClick={onNextButtonClick}
    >
      <Flex vertical gap="1rem">
        <Form.Item<CoverWizardForm>
          colon={false}
          label="Attach Pre-Printed Measure Form"
          className="pool-cover-quote-dragger-form-item"
          getValueFromEvent={normFile}
          name={dropzoneFieldName}
        >
          <FileDropzone
            allowedFileExtensions={allowedFileExtensions}
            onChange={(fileList) => {
              form.setFieldValue(dropzoneFieldName, fileList);
            }}
            fileList={fileList}
            deleteFile={(file) =>
              form.setFieldValue(
                dropzoneFieldName,
                fileList.filter((x) => x.uid !== file.uid)
              )
            }
          />
        </Form.Item>
        <Form.Item<CoverWizardForm>
          name={distanceFieldName}
          label="Distance from A-B"
        >
          <Input placeholder="Filter text" />
        </Form.Item>
      </Flex>
    </WizardPageWrapper>
  );
}
